<template>
	<UITopHeading>{{ error?.statusCode }}</UITopHeading>
	<div class="container mt-20 items-center text-center text-rose-600">
		<h3>{{ error?.message }}</h3>
		<p>Hoppla! Etwas ist schiefgelaufen.</p>
		<p>
			Keine Sorge, unser Team hochqualifizierter Affen arbeitet hart daran,
			dieses Problem zu beheben.
		</p>
		<p class="mb-6">
			In der Zwischenzeit können Sie versuchen, die Seite zu aktualisieren oder
			später zurückzukommen.
		</p>
		<UButton variant="outline" @click="handleError">
			Zurück zur Startseite
		</UButton>
	</div>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app'

defineProps({
	error: Object as () => NuxtError,
})

const handleError = () => clearError({ redirect: '/' })
</script>

<style scoped></style>
